import { GeoDataMap } from '@shared/abstraction';
import { TaxStatusThreshold } from '@shared/helpers/enums/tax-status-threshold';

export const chartGlobalData: GeoDataMap = [
  ['fo', TaxStatusThreshold.NoInvestment],
  ['um', TaxStatusThreshold.NoInvestment],
  ['us', TaxStatusThreshold.NoInvestment],
  ['jp', TaxStatusThreshold.NoInvestment],
  ['sc', TaxStatusThreshold.NoInvestment],
  ['in', TaxStatusThreshold.NoInvestment],
  ['fr', TaxStatusThreshold.NoInvestment],
  ['fm', TaxStatusThreshold.NoInvestment],
  ['cn', TaxStatusThreshold.NoInvestment],
  ['pt', TaxStatusThreshold.NoInvestment],
  ['sw', TaxStatusThreshold.NoInvestment],
  ['sh', TaxStatusThreshold.NoInvestment],
  ['br', TaxStatusThreshold.NoInvestment],
  ['ki', TaxStatusThreshold.NoInvestment],
  ['ph', TaxStatusThreshold.NoInvestment],
  ['mx', TaxStatusThreshold.NoInvestment],
  ['es', TaxStatusThreshold.NoInvestment],
  ['bu', TaxStatusThreshold.NoInvestment],
  ['mv', TaxStatusThreshold.NoInvestment],
  ['sp', TaxStatusThreshold.NoInvestment],
  ['gb', TaxStatusThreshold.NoInvestment],
  ['gr', TaxStatusThreshold.NoInvestment],
  ['as', TaxStatusThreshold.NoInvestment],
  ['dk', TaxStatusThreshold.NoInvestment],
  ['gl', TaxStatusThreshold.NoInvestment],
  ['gu', TaxStatusThreshold.NoInvestment],
  ['mp', TaxStatusThreshold.NoInvestment],
  ['pr', TaxStatusThreshold.NoInvestment],
  ['vi', TaxStatusThreshold.NoInvestment],
  ['ca', TaxStatusThreshold.NoInvestment],
  ['st', TaxStatusThreshold.NoInvestment],
  ['cv', TaxStatusThreshold.NoInvestment],
  ['dm', TaxStatusThreshold.NoInvestment],
  ['nl', TaxStatusThreshold.NoInvestment],
  ['jm', TaxStatusThreshold.NoInvestment],
  ['ws', TaxStatusThreshold.NoInvestment],
  ['om', TaxStatusThreshold.NoInvestment],
  ['vc', TaxStatusThreshold.NoInvestment],
  ['tr', TaxStatusThreshold.NoInvestment],
  ['bd', TaxStatusThreshold.NoInvestment],
  ['lc', TaxStatusThreshold.NoInvestment],
  ['nr', TaxStatusThreshold.NoInvestment],
  ['no', TaxStatusThreshold.NoInvestment],
  ['kn', TaxStatusThreshold.NoInvestment],
  ['bh', TaxStatusThreshold.NoInvestment],
  ['to', TaxStatusThreshold.NoInvestment],
  ['fi', TaxStatusThreshold.NoInvestment],
  ['id', TaxStatusThreshold.NoInvestment],
  ['mu', TaxStatusThreshold.NoInvestment],
  ['se', TaxStatusThreshold.NoInvestment],
  ['tt', TaxStatusThreshold.NoInvestment],
  ['my', TaxStatusThreshold.NoInvestment],
  ['pa', TaxStatusThreshold.NoInvestment],
  ['pw', TaxStatusThreshold.NoInvestment],
  ['tv', TaxStatusThreshold.NoInvestment],
  ['mh', TaxStatusThreshold.NoInvestment],
  ['cl', TaxStatusThreshold.NoInvestment],
  ['th', TaxStatusThreshold.NoInvestment],
  ['gd', TaxStatusThreshold.NoInvestment],
  ['ee', TaxStatusThreshold.NoInvestment],
  ['ag', TaxStatusThreshold.NoInvestment],
  ['tw', TaxStatusThreshold.NoInvestment],
  ['bb', TaxStatusThreshold.NoInvestment],
  ['it', TaxStatusThreshold.NoInvestment],
  ['mt', TaxStatusThreshold.NoInvestment],
  ['vu', TaxStatusThreshold.NoInvestment],
  ['sg', TaxStatusThreshold.NoInvestment],
  ['cy', TaxStatusThreshold.NoInvestment],
  ['lk', TaxStatusThreshold.NoInvestment],
  ['km', TaxStatusThreshold.NoInvestment],
  ['fj', TaxStatusThreshold.NoInvestment],
  ['ru', TaxStatusThreshold.NoInvestment],
  ['va', TaxStatusThreshold.NoInvestment],
  ['sm', TaxStatusThreshold.NoInvestment],
  ['kz', TaxStatusThreshold.NoInvestment],
  ['az', TaxStatusThreshold.NoInvestment],
  ['tj', TaxStatusThreshold.NoInvestment],
  ['ls', TaxStatusThreshold.NoInvestment],
  ['uz', TaxStatusThreshold.NoInvestment],
  ['ma', TaxStatusThreshold.NoInvestment],
  ['co', TaxStatusThreshold.NoInvestment],
  ['tl', TaxStatusThreshold.NoInvestment],
  ['tz', TaxStatusThreshold.NoInvestment],
  ['ar', TaxStatusThreshold.NoInvestment],
  ['sa', TaxStatusThreshold.NoInvestment],
  ['pk', TaxStatusThreshold.NoInvestment],
  ['ye', TaxStatusThreshold.NoInvestment],
  ['ae', TaxStatusThreshold.NoInvestment],
  ['ke', TaxStatusThreshold.NoInvestment],
  ['pe', TaxStatusThreshold.NoInvestment],
  ['do', TaxStatusThreshold.NoInvestment],
  ['ht', TaxStatusThreshold.NoInvestment],
  ['pg', TaxStatusThreshold.NoInvestment],
  ['ao', TaxStatusThreshold.NoInvestment],
  ['kh', TaxStatusThreshold.NoInvestment],
  ['vn', TaxStatusThreshold.NoInvestment],
  ['mz', TaxStatusThreshold.NoInvestment],
  ['cr', TaxStatusThreshold.NoInvestment],
  ['bj', TaxStatusThreshold.NoInvestment],
  ['ng', TaxStatusThreshold.NoInvestment],
  ['ir', TaxStatusThreshold.NoInvestment],
  ['sv', TaxStatusThreshold.NoInvestment],
  ['sl', TaxStatusThreshold.NoInvestment],
  ['gw', TaxStatusThreshold.NoInvestment],
  ['hr', TaxStatusThreshold.NoInvestment],
  ['bz', TaxStatusThreshold.NoInvestment],
  ['za', TaxStatusThreshold.NoInvestment],
  ['cf', TaxStatusThreshold.NoInvestment],
  ['sd', TaxStatusThreshold.NoInvestment],
  ['cd', TaxStatusThreshold.NoInvestment],
  ['kw', TaxStatusThreshold.NoInvestment],
  ['de', TaxStatusThreshold.NoInvestment],
  ['be', TaxStatusThreshold.NoInvestment],
  ['ie', TaxStatusThreshold.NoInvestment],
  ['kp', TaxStatusThreshold.NoInvestment],
  ['kr', TaxStatusThreshold.NoInvestment],
  ['gy', TaxStatusThreshold.NoInvestment],
  ['hn', TaxStatusThreshold.NoInvestment],
  ['mm', TaxStatusThreshold.NoInvestment],
  ['ga', TaxStatusThreshold.NoInvestment],
  ['gq', TaxStatusThreshold.NoInvestment],
  ['ni', TaxStatusThreshold.NoInvestment],
  ['lv', TaxStatusThreshold.NoInvestment],
  ['ug', TaxStatusThreshold.NoInvestment],
  ['mw', TaxStatusThreshold.NoInvestment],
  ['am', TaxStatusThreshold.NoInvestment],
  ['sx', TaxStatusThreshold.NoInvestment],
  ['tm', TaxStatusThreshold.NoInvestment],
  ['zm', TaxStatusThreshold.NoInvestment],
  ['nc', TaxStatusThreshold.NoInvestment],
  ['mr', TaxStatusThreshold.NoInvestment],
  ['dz', TaxStatusThreshold.NoInvestment],
  ['lt', TaxStatusThreshold.NoInvestment],
  ['et', TaxStatusThreshold.NoInvestment],
  ['er', TaxStatusThreshold.NoInvestment],
  ['gh', TaxStatusThreshold.NoInvestment],
  ['si', TaxStatusThreshold.NoInvestment],
  ['gt', TaxStatusThreshold.NoInvestment],
  ['ba', TaxStatusThreshold.NoInvestment],
  ['jo', TaxStatusThreshold.NoInvestment],
  ['sy', TaxStatusThreshold.NoInvestment],
  ['mc', TaxStatusThreshold.NoInvestment],
  ['al', TaxStatusThreshold.NoInvestment],
  ['uy', TaxStatusThreshold.NoInvestment],
  ['cnm', TaxStatusThreshold.NoInvestment],
  ['mn', TaxStatusThreshold.NoInvestment],
  ['rw', TaxStatusThreshold.NoInvestment],
  ['so', TaxStatusThreshold.NoInvestment],
  ['bo', TaxStatusThreshold.NoInvestment],
  ['cm', TaxStatusThreshold.NoInvestment],
  ['cg', TaxStatusThreshold.NoInvestment],
  ['eh', TaxStatusThreshold.NoInvestment],
  ['rs', TaxStatusThreshold.NoInvestment],
  ['me', TaxStatusThreshold.NoInvestment],
  ['tg', TaxStatusThreshold.NoInvestment],
  ['la', TaxStatusThreshold.NoInvestment],
  ['af', TaxStatusThreshold.NoInvestment],
  ['ua', TaxStatusThreshold.NoInvestment],
  ['sk', TaxStatusThreshold.NoInvestment],
  ['jk', TaxStatusThreshold.NoInvestment],
  ['bg', TaxStatusThreshold.NoInvestment],
  ['qa', TaxStatusThreshold.NoInvestment],
  ['li', TaxStatusThreshold.NoInvestment],
  ['at', TaxStatusThreshold.NoInvestment],
  ['sz', TaxStatusThreshold.NoInvestment],
  ['hu', TaxStatusThreshold.NoInvestment],
  ['ro', TaxStatusThreshold.NoInvestment],
  ['ne', TaxStatusThreshold.NoInvestment],
  ['lu', TaxStatusThreshold.NoInvestment],
  ['ad', TaxStatusThreshold.NoInvestment],
  ['ci', TaxStatusThreshold.NoInvestment],
  ['lr', TaxStatusThreshold.NoInvestment],
  ['bn', TaxStatusThreshold.NoInvestment],
  ['iq', TaxStatusThreshold.NoInvestment],
  ['ge', TaxStatusThreshold.NoInvestment],
  ['gm', TaxStatusThreshold.NoInvestment],
  ['ch', TaxStatusThreshold.NoInvestment],
  ['td', TaxStatusThreshold.NoInvestment],
  ['kv', TaxStatusThreshold.NoInvestment],
  ['lb', TaxStatusThreshold.NoInvestment],
  ['dj', TaxStatusThreshold.NoInvestment],
  ['bi', TaxStatusThreshold.NoInvestment],
  ['sr', TaxStatusThreshold.NoInvestment],
  ['il', TaxStatusThreshold.NoInvestment],
  ['ml', TaxStatusThreshold.NoInvestment],
  ['sn', TaxStatusThreshold.NoInvestment],
  ['gn', TaxStatusThreshold.NoInvestment],
  ['zw', TaxStatusThreshold.NoInvestment],
  ['pl', TaxStatusThreshold.NoInvestment],
  ['mk', TaxStatusThreshold.NoInvestment],
  ['py', TaxStatusThreshold.NoInvestment],
  ['by', TaxStatusThreshold.NoInvestment],
  ['cz', TaxStatusThreshold.NoInvestment],
  ['bf', TaxStatusThreshold.NoInvestment],
  ['na', TaxStatusThreshold.NoInvestment],
  ['ly', TaxStatusThreshold.NoInvestment],
  ['tn', TaxStatusThreshold.NoInvestment],
  ['bt', TaxStatusThreshold.NoInvestment],
  ['md', TaxStatusThreshold.NoInvestment],
  ['ss', TaxStatusThreshold.NoInvestment],
  ['bw', TaxStatusThreshold.NoInvestment],
  ['bs', TaxStatusThreshold.NoInvestment],
  ['nz', TaxStatusThreshold.NoInvestment],
  ['cu', TaxStatusThreshold.NoInvestment],
  ['ec', TaxStatusThreshold.NoInvestment],
  ['au', TaxStatusThreshold.NoInvestment],
  ['ve', TaxStatusThreshold.NoInvestment],
  ['sb', TaxStatusThreshold.NoInvestment],
  ['mg', TaxStatusThreshold.NoInvestment],
  ['is', TaxStatusThreshold.NoInvestment],
  ['eg', TaxStatusThreshold.NoInvestment],
  ['kg', TaxStatusThreshold.NoInvestment],
  ['np', TaxStatusThreshold.NoInvestment],
];
